import { servicesWordsApi } from './shared/services';
import { audioGame } from './games/audioGame';
import { controllers } from './controllers/controller';
import { nav } from './view/components/nav';
import { statistics, statisticsChart } from './view/components/statistics';
import { sprintGame } from './games/sprintGame';
var app = {
    start: function () {
        console.log('Start App');
        nav();
        audioGame();
        statistics();
        statisticsChart();
        controllers.init();
        sprintGame();
    },
    testSevice: function () {
        servicesWordsApi.getWords();
    },
};
export { app };
